import LoginPage from "Components/Auth/login";
import { Outlet } from "react-router-dom";
import { session } from "Utils";

export default function PrivateRoutes() {
  const isAuth = session.get("token");
  return <div>{isAuth ? <Outlet /> : <LoginPage />}</div>;
}
